export default function ExtendedSearchFeatured() {
  const extendedSearchBlock = document.querySelectorAll<HTMLDivElement>(".js-extended-search-featured-block");

  if (extendedSearchBlock && extendedSearchBlock.length > 0) {
    extendedSearchBlock.forEach((item) => {
      const itemsWrapper: HTMLDivElement | null = item.querySelector(".js-extended-search-items");
      const items = item.querySelectorAll<HTMLDivElement>(".js-item");
      const loadMoreBtnWrapper: HTMLDivElement | null = item.querySelector(".js-btn-wrapper");
      const loadMoreBtn: HTMLButtonElement | null = item.querySelector(".js-load-more-btn");
      let hiddenItems: HTMLDivElement[] | null = [];

      const calculateHiddenItems = () => {
        items.forEach((item) => {
          if (hiddenItems && item.classList.contains("hidden")) {
            hiddenItems.push(item);
          }
        });
      }

      calculateHiddenItems()

       const toggleItems = () => {
         if (hiddenItems && hiddenItems.length > 0) {
           const itemsToCheck = hiddenItems.slice(0, 3);
           itemsToCheck.forEach((item) => {
             if (item.classList.contains("hidden")) {
               item.classList.remove("hidden");
             }
           });
           hiddenItems = hiddenItems.slice(3);
         }
         hideLoadMore();
       };

      const hideLoadMore = () => {
        if(loadMoreBtnWrapper && loadMoreBtn) {
          if (hiddenItems && hiddenItems.length <= 0) {
            loadMoreBtnWrapper.style.display = "none";
          }
        }
      }

      hideLoadMore()
      
      if (itemsWrapper && loadMoreBtnWrapper && loadMoreBtn) {
        loadMoreBtn.addEventListener("click", () => {
          toggleItems();
        });
      }
    });
  }
}
